import React, { useEffect, useState } from 'react';

function StatusDot(props: StatusDotProps) {

    function sizeToPx(size: string) {
        switch (size) {
            case "sm": return "10px";
            case "md": return "20px";
            case "lg": return "30px";
            default: return size;
        }
    }

    return (
        <div style={{
            backgroundColor: props.color,
            width: sizeToPx(props.size),
            height: sizeToPx(props.size),
            borderRadius: "50%",
            display: "inline-block"
        }}></div>
    );
}

class StatusDotProps {
    color: string = "";
    size: string = "";
}

export default StatusDot;